import { axiosPut } from 'shared/api/axios'
import { apiUrls } from 'consts'

interface filterRoleChangeProps {
  filter_role_id: number
  setShowOverlay: Function
}

const processFilterRoleChange = async (props: filterRoleChangeProps) => {
  const payload = {
    filter_role_id: props.filter_role_id,
  }
  return await axiosPut(apiUrls.users + '/' + apiUrls.actionChangeFilterRole, payload, () => {})
}

export default processFilterRoleChange
